import cn from "classnames";
import React from "react";

import { Token } from "@/widgets/chart-list/constants";
import { getBrandColorByToken } from "@/widgets/chart-list/utils/get-brand-color-by-token";
import { getIconByToken } from "@/widgets/chart-list/utils/get-icon-by-token";

import { TabItem } from "../styled";
import * as S from "./styled";

const labelByToken: Record<Token, string> = {
  [Token.GMX]: "GMX",
  [Token.USDC]: "USDC",
  [Token.USDCE]: "USDC.e",
  [Token.WETH]: "ETH",
  [Token.ARB]: "ARB",
  [Token.WBTC]: "WBTC",
};

interface Props {
  isActive: boolean;
  tokens: [Token, Token];
  onClick: () => void;
}

export function Tab({ isActive, onClick, tokens }: Props) {
  const [baseToken, quoteToken] = tokens;
  return (
    <TabItem className={cn(isActive && "active")} onClick={onClick}>
      <S.IconsBar>
        <S.IconArea $color={isActive && getBrandColorByToken(baseToken)}>
          {getIconByToken(baseToken)}
        </S.IconArea>
        <S.IconArea $color={isActive && getBrandColorByToken(quoteToken)}>
          {getIconByToken(quoteToken)}
        </S.IconArea>
      </S.IconsBar>
      <div>
        <div>{labelByToken[baseToken]}</div>
        <div>{labelByToken[quoteToken]}</div>
      </div>
    </TabItem>
  );
}
